module.exports = __webpack_public_path__ + "static/img_4821-f916f8c3c738dfd3f6627ef26e842068.webp";